<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-02-22 13:50:10
 * @LastEditTime: 2019-03-21 19:14:51
 -->
<template>
    <div class="prodDetails ">
        <!-- <div class="way">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <div class="main">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <div class="btn"
                         :style="{width:overwidth}"
                         v-for="(item,index) in brotherMenu"
                         :key="index"
                         @click="assign(item)"
                         :class="{active: activeIndex === item.id}">
                        <p class="line">{{item.name}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <keep-alive>
            <component :is="currentpage"></component>
        </keep-alive>
    </div>
</template>
<script>
import smallPieces from "@/views/products/smallPieces";
import business from "@/views/products/business";
import heavyCargo from "@/views/products/heavyCargo";
import toDoor from "@/views/products/toDoor";
import transportation from "@/views/products/transportation";
import breadcrumb from "@/components/breadcrumb";
import { mapGetters } from "vuex";
export default {
    components: {
        smallPieces,
        business,
        heavyCargo,
        toDoor,
        transportation,
        breadcrumb
    },
    data() {
        return {
            position: "",
            overwidth: "20%",
            currentpage: "smallPieces",
            list: [
                { name: "smallPieces", title: "壹米小件" },
                { name: "toDoor", title: "滴答到门" },
                { name: "transportation", title: "小票快运" },
                { name: "heavyCargo", title: "壹米重货" },
                { name: "business", title: "整车业务" }
            ]
        };
    },
    computed: {
        ...mapGetters(["activeIndex", "parentList", "brotherMenu"])
    },
    // created () {
    //     debugger;
    //     console.log(this.activeIndex);
    //     console.log(this.$route.params.id);
    //     this.currentpage = this.$route.params.id;
    //     // this.activeIndex = sessionStorage.getItem("activeIndex");
    //     if (this.$route.query.id) {
    //         console.log(sessionStorage.getItem("activeIndex"));
    //         this.$store.dispatch(
    //             "ContentDescList",
    //             this.$route.query.id
    //         );
    //     }
    //     console.log(this.brotherMenu);
    // },
    watch: {
        //监听路由变化
        $route(to, from) {
            this.currentpage = this.$route.params.id;
        }
    },

    methods: {
        search() {
            switch (this.$route.params.id) {
                // console.log(this.$router.path);
                case "smallPieces":
                    this.position = "壹米小件";
                    break;
                case "toDoor":
                    this.position = "滴答到门";
                    break;
                case "transportation":
                    this.position = "小票快运";
                    break;
                case "heavyCargo":
                    this.position = "壹米重货";
                    break;
                case "business":
                    this.position = "整车业务";
                    break;
            }
        },
        assign(item) {
            // this.$store.dispatch("UpdateActive", item);
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.id
                }
            });
            this.$store.dispatch("BannerPath", item.id);
            this.$store.dispatch("ContentDescList", item.id);
        }
    }
};
</script>

<style scoped lang="scss">
.prodDetails {
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
    .main {
        background-color: #fff;
        .btn {
            cursor: pointer;
            height: 54px;
            margin: 0 auto;
            display: inline-block;
            text-align: center;
            font-size: 20px;
            line-height: 54px;
        }
    }
    .active {
        border-bottom: 2px solid #fabe00;
    }
}
</style>
